@if (formData.formGroup) {
  <div class="input-wrapper"
       (click)="uploadImage.click()">
    <section class="input-section">
      <input [type]="formData.type"
             class="input"
             #uploadImage
             [id]="formData.id"
             [accept]="formData.accept"
             [multiple]="formData.multiple"
             hidden
             (change)="onFileChange($event)">

      <span class="material-symbols-rounded upload-icon">
        upload_file
      </span>

      <p class="upload-text">
        Bilder hochladen
      </p>
    </section>

    @if (selectedFilePreviews.length > 0) {
      <div class="selected-files">
        @for (file of selectedFilePreviews; track file.file.name) {
          <img class="selected-file" src="{{ file.url }}" alt="New Image">
        }
      </div>
    }
  </div>
} @else if (formData.onInput) {
  <div class="input-wrapper"
       (click)="uploadImage.click()">
    <section class="input-section">
      <input [type]="formData.type"
             class="input"
             #uploadImage
             [id]="formData.id"
             [accept]="formData.accept"
             [multiple]="formData.multiple"
             hidden
             (change)="onFileChange($event)">

      <span class="material-symbols-rounded upload-icon">
        upload_file
      </span>

      <p class="upload-text">
        Bilder hochladen
      </p>
    </section>

    @if (selectedFilePreviews.length > 0) {
      <div class="selected-files">
        @for (file of selectedFilePreviews; track file.file.name) {
          <img class="selected-file" src="{{ file.url }}">
        }
      </div>
    }
  </div>
}